import { gql } from '@apollo/client';

export const getChannelPlatformToken = gql`
  query channelPlatformToken {
    supportInquiry_channelsIdentityHash
  }
`;

export const getChannelPlatformTokenByClientName = gql`
  query channelPlatformTokenGenerationByClientName($clientName: String) {
    supportInquiry_channelsIdentityHashByClientName(request: { clientName: $clientName })
  }
`;

export const getChatConnectionConfigForSalesChannel = gql`
  query CreateContact(
    $requestType: ChannelPlatformChannelType!
    $payload: JSON
    $metadata: JSON
    $attributes: JSON
    $anonymousId: String
  ) {
    channelPlatform_createContact(
      requestType: $requestType
      request: { payload: $payload, metadata: $metadata, attributes: $attributes }
      anonymousId: $anonymousId
    ) {
      channel
      value {
        ... on ChannelPlatformGetChannelTokenResponse {
          participantId
          participantToken
          region
          contactId
        }
      }
    }
  }
`;

export const getCustomerConversations = gql`
  query CustomerConversations($anonymousId: String) {
    channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
      conversations
    }
  }
`;
